import { useEffect, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Layout
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";

// Pages
import Home from "@/pages/Home";
import Framework from "@/pages/Framework";
import PillarDetail from "@/pages/PillarDetail";
import Protocols from "@/pages/Protocols";
import ProtocolDetail from "@/pages/ProtocolDetail";
import Toolkits from "@/pages/Toolkits";
import ToolkitDetail from "@/pages/ToolkitDetail";
import DataGuides from "@/pages/DataGuides";
import DataGuideDetail from "@/pages/DataGuideDetail";
import Training from "@/pages/Training";
import About from "@/pages/About";
import Admin from "@/pages/Admin";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with base URL
export const api = axios.create({
  baseURL: API,
});

function App() {
  const seedDatabase = useCallback(async () => {
    try {
      await api.post("/seed");
    } catch (e) {
      // Already seeded or error - no action needed
    }
  }, []);

  useEffect(() => {
    seedDatabase();
  }, [seedDatabase]);

  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="framework" element={<Framework />} />
            <Route path="framework/:slug" element={<PillarDetail />} />
            <Route path="protocols" element={<Protocols />} />
            <Route path="protocols/:slug" element={<ProtocolDetail />} />
            <Route path="toolkits" element={<Toolkits />} />
            <Route path="toolkits/:slug" element={<ToolkitDetail />} />
            <Route path="data" element={<DataGuides />} />
            <Route path="data/:slug" element={<DataGuideDetail />} />
            <Route path="training" element={<Training />} />
            <Route path="about" element={<About />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
